import { useSyncExternalStore } from 'react';
import { registerSW } from 'virtual:pwa-register';
type OfflineState = { ready: boolean; updateAvailable: boolean; error: boolean; online: boolean };
let current: OfflineState = { ready: false, updateAvailable: false, error: false, online: navigator.onLine };
const listeners = new Set<() => void>();
const change = (patch: Partial<OfflineState>) => { current = { ...current, ...patch }; listeners.forEach((f) => f()); };
export function initializeOffline() {
  window.addEventListener('online', () => change({ online: true }));
  window.addEventListener('offline', () => change({ online: false }));
  // Database opening can outlast a connectivity change during startup.
  change({ online: navigator.onLine });
  if (import.meta.env.PROD && 'serviceWorker' in navigator) {
    registerSW({ immediate: true,
      onOfflineReady: () => change({ ready: true }),
      onNeedRefresh: () => change({ updateAvailable: true }),
      onRegisterError: () => change({ error: true }),
    });
    void navigator.serviceWorker.ready.then(() => change({ ready: true }));
  }
}
export function useOffline() {
  return useSyncExternalStore(listener=>{listeners.add(listener);return()=>{listeners.delete(listener);};},()=>current);
}
